var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_262_6347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.375 5.97707V18.069C2.42152 22.0645 3.69483 25.9492 6.0225 29.197C8.35017 32.4448 11.6197 34.8988 15.3884 36.2266L17.1633 36.8821C18.3491 37.3176 19.6509 37.3176 20.8367 36.8821L22.6116 36.2266C26.3803 34.8988 29.6498 32.4448 31.9775 29.197C34.3052 25.9492 35.5785 22.0645 35.625 18.069V5.97707C35.6234 5.502 35.4824 5.03784 35.2196 4.64212C34.9567 4.2464 34.5835 3.93653 34.1462 3.7509C29.3499 1.74902 24.197 0.742249 19 0.791651C13.803 0.742249 8.65008 1.74902 3.85383 3.7509C3.41653 3.93653 3.04331 4.2464 2.78043 4.64212C2.51756 5.03784 2.37659 5.502 2.375 5.97707V5.97707Z",
    fill: "#E8EBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0.791651C13.803 0.742249 8.65008 1.74902 3.85383 3.7509C3.41653 3.93653 3.04331 4.2464 2.78043 4.64212C2.51756 5.03784 2.37659 5.502 2.375 5.97707V18.069C2.42152 22.0645 3.69483 25.9492 6.0225 29.197C8.35017 32.4448 11.6197 34.8988 15.3884 36.2267L17.1633 36.8822C17.7517 37.0978 18.3734 37.2082 19 37.2083V0.791651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.375 5.97707V18.069C2.42152 22.0645 3.69483 25.9492 6.0225 29.197C8.35017 32.4448 11.6197 34.8988 15.3884 36.2266L17.1633 36.8821C18.3491 37.3176 19.6509 37.3176 20.8367 36.8821L22.6116 36.2266C26.3803 34.8988 29.6498 32.4448 31.9775 29.197C34.3052 25.9492 35.5785 22.0645 35.625 18.069V5.97707C35.6234 5.502 35.4824 5.03784 35.2196 4.64212C34.9567 4.2464 34.5835 3.93653 34.1462 3.7509C29.3499 1.74902 24.197 0.742249 19 0.791651C13.803 0.742249 8.65008 1.74902 3.85383 3.7509C3.41653 3.93653 3.04331 4.2464 2.78043 4.64212C2.51756 5.03784 2.37659 5.502 2.375 5.97707V5.97707Z",
    stroke: "#00426B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5417 14.6348H13.4583C12.5839 14.6348 11.875 15.3436 11.875 16.2181V25.7165C11.875 26.591 12.5839 27.2999 13.4583 27.2999H24.5417C25.4161 27.2999 26.125 26.591 26.125 25.7165V16.2181C26.125 15.3436 25.4161 14.6348 24.5417 14.6348Z",
    fill: "#F6E599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14.6348H13.4583C13.0384 14.6348 12.6357 14.8016 12.3387 15.0985C12.0418 15.3954 11.875 15.7982 11.875 16.2181V25.7181C11.875 26.138 12.0418 26.5408 12.3387 26.8377C12.6357 27.1346 13.0384 27.3014 13.4583 27.3014H19V14.6348Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5417 14.6348H13.4583C12.5839 14.6348 11.875 15.3436 11.875 16.2181V25.7165C11.875 26.591 12.5839 27.2999 13.4583 27.2999H24.5417C25.4161 27.2999 26.125 26.591 26.125 25.7165V16.2181C26.125 15.3436 25.4161 14.6348 24.5417 14.6348Z",
    stroke: "#00426B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9987 23.047C20.0918 23.047 20.9779 22.1609 20.9779 21.0679C20.9779 19.9748 20.0918 19.0887 18.9987 19.0887C17.9056 19.0887 17.0195 19.9748 17.0195 21.0679C17.0195 22.1609 17.9056 23.047 18.9987 23.047Z",
    fill: "#FDEEAF",
    stroke: "#00426B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9596 12.2597C22.9596 11.2099 22.5426 10.2031 21.8003 9.46076C21.0579 8.71843 20.0511 8.30139 19.0013 8.30139C17.9515 8.30139 16.9447 8.71843 16.2023 9.46076C15.46 10.2031 15.043 11.2099 15.043 12.2597V14.6347H22.9596V12.2597Z",
    stroke: "#00426B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_6347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldLock);
export default __webpack_public_path__ + "static/media/shield-lock.b2a8295b0096e23deabef33c9ffeef57.svg";
export { ForwardRef as ReactComponent };